import { Log } from 'ng2-logger';
import { Dispatch } from 'react';
import ReactGA from 'react-ga4';

const _logger = Log.create('google-analytics-middleware');

let currentPage = '';

const GoogleAnalytics = (store: any) => {
    return (next: Dispatch<any>) => {
        return (action: any) => {


          const main = JSON.parse(localStorage.getItem('persist:almsPlusPersist')!);

          const innerLogin = (main) ? JSON.parse(main.login) : {};

            if ((window.appSettings.GOOGLE_ANLYTICS_CODE || localStorage.getItem('googleAnalyticsCode')) && action.type === '@@router/LOCATION_CHANGE') {
                const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`;

                if (currentPage !== nextPage) {
                    currentPage = nextPage;

                    if (action.spinnerId == "LoginFormSubmitLoading" && innerLogin)
                    {
                      ReactGA.initialize([
                        {
                          //almsp GOOGLE_ANLYTICS_CODE
                          trackingId:  window.appSettings.GOOGLE_ANLYTICS_CODE,
                        },
                        {
                          //kurum GOOGLE_ANLYTICS_CODE
                          trackingId: localStorage.getItem('googleAnalyticsCode')!,
                        },
                      ]);

                      ReactGA.set({
                        'type': innerLogin.identitiy.userType
                      })
                      
                    }
                    else
                    {
                      ReactGA.initialize([
                        {
                          //almsp GOOGLE_ANLYTICS_CODE
                          trackingId:  window.appSettings.GOOGLE_ANLYTICS_CODE,
                        },
                        {
                          //kurum GOOGLE_ANLYTICS_CODE
                          trackingId: localStorage.getItem('googleAnalyticsCode')!
                        },
                      ])
                    }

                    ReactGA.send({ hitType: 'pageview', page: nextPage, send_to: window.appSettings.GOOGLE_ANLYTICS_CODE  });

                    ReactGA.send({ hitType: 'pageview', page: nextPage, send_to: localStorage.getItem('googleAnalyticsCode')!  });
                }   
            }
            return next(action);
        };
    };
};


export default GoogleAnalytics;
